import React from "react";
import ContentLoader from "react-content-loader";
import {
  GoStack,
  GoLocation,
  GoGraph,
  GoPeople,
  GoLaw,
  GoCalendar,
  GoArrowUp,
} from "react-icons/go";

const ClientsStatsLoadingSkeleton = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  return (
    <div className="stats-tab">
      {/* Container para todas as linhas de gráficos */}
      <div className="charts-container">
        {/* Linha 1: Donut, Top Estados e Mapa */}
        <div
          className="charts-row"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "20px",
          }}
        >
          {/* Card Donut Chart - Distribuição por Entidade */}
          <div className="stats-section chart-card">
            <div className="section-header">
              <GoStack />
              <h4>Distribuição por Entidade</h4>
            </div>
            <div className="donut-wrapper" style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "100%", width: "100%", gap: "20px", paddingBottom: "40px" }}>
              <div className="donut-chart">
                <div style={{ 
                  width: "180px", 
                  height: "180px", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center" 
                }}>
                  <div style={{
                    width: "40px",
                    height: "40px",
                    border: "4px solid rgba(139, 92, 246, 0.2)",
                    borderTop: "4px solid #8b5cf6",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite"
                  }}></div>
                </div>
                <style>{`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}</style>
              </div>
              <div className="categories-list">
                {[...Array(3)].map((_, i) => (
                  <div key={`entity-${i}`} className="category-item">
                    <div className="category-header">
                      <div
                        className="category-color"
                        style={{ backgroundColor: ["#3b82f6", "#10b981", "#f59e0b"][i] }}
                      ></div>
                      <span className="category-name">
                        <ContentLoader
                          speed={2}
                          width={80}
                          height={11}
                          backgroundColor={backgroundColor}
                          foregroundColor={foregroundColor}
                        >
                          <rect x="0" y="0" rx="3" ry="3" width="80" height="11" />
                        </ContentLoader>
                      </span>
                      <span className="category-count">
                        <ContentLoader
                          speed={2}
                          width={30}
                          height={11}
                          backgroundColor={backgroundColor}
                          foregroundColor={foregroundColor}
                        >
                          <rect x="0" y="0" rx="3" ry="3" width="30" height="11" />
                        </ContentLoader>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Card Top Estados */}
          <div className="stats-section chart-card">
            <div className="section-header">
              <GoLocation />
              <h4>Top Estados</h4>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                padding: "4px 0",
                maxHeight: "320px",
                overflowY: "auto",
                paddingRight: "4px",
              }}
              className="custom-scrollbar"
            >
              {[...Array(8)].map((_, i) => {
                const colors = ["#10b981", "#3b82f6", "#8b5cf6", "#f59e0b", "#64748b"];
                const color = colors[i % colors.length];
                return (
                  <div
                    key={`state-${i}`}
                    style={{
                      background: `linear-gradient(135deg, ${color}08 0%, transparent 100%)`,
                      borderRadius: "10px",
                      padding: "12px 14px",
                      border: `1px solid ${color}20`,
                      position: "relative",
                      overflow: "hidden",
                      minHeight: "52px",
                      flexShrink: 0,
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        height: "100%",
                        width: `${100 - i * 10}%`,
                        background: `linear-gradient(90deg, ${color}15 0%, ${color}05 100%)`,
                        borderRadius: "10px",
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          style={{
                            width: "28px",
                            height: "28px",
                            borderRadius: "8px",
                            background: i < 3 ? `linear-gradient(135deg, ${color} 0%, ${color}cc 100%)` : "rgba(100, 116, 139, 0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "0.75em",
                            fontWeight: 700,
                            color: i < 3 ? "#fff" : "#94a3b8",
                          }}
                        >
                          {i + 1}
                        </div>
                        <div>
                          <ContentLoader
                            speed={2}
                            width={120}
                            height={11}
                            backgroundColor={backgroundColor}
                            foregroundColor={foregroundColor}
                          >
                            <rect x="0" y="0" rx="3" ry="3" width="120" height="11" />
                          </ContentLoader>
                          <div style={{ marginTop: "4px" }}>
                            <ContentLoader
                              speed={2}
                              width={80}
                              height={9}
                              backgroundColor={backgroundColor}
                              foregroundColor={foregroundColor}
                            >
                              <rect x="0" y="0" rx="3" ry="3" width="80" height="9" />
                            </ContentLoader>
                          </div>
                        </div>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <ContentLoader
                          speed={2}
                          width={90}
                          height={13}
                          backgroundColor={backgroundColor}
                          foregroundColor={foregroundColor}
                        >
                          <rect x="0" y="0" rx="3" ry="3" width="90" height="13" />
                        </ContentLoader>
                        <div style={{ marginTop: "4px" }}>
                          <ContentLoader
                            speed={2}
                            width={50}
                            height={9}
                            backgroundColor={backgroundColor}
                            foregroundColor={foregroundColor}
                          >
                            <rect x="0" y="0" rx="3" ry="3" width="50" height="9" />
                          </ContentLoader>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Card Mapa do Brasil */}
          <div className="stats-section chart-card">
            <div className="section-header">
              <GoLocation />
              <h4>Mapa do Brasil</h4>
            </div>
            <div style={{ 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              justifyContent: "center", 
              padding: "24px", 
              flex: 1, 
              minHeight: "320px" 
            }}>
              <div style={{
                width: "40px",
                height: "40px",
                border: "4px solid rgba(139, 92, 246, 0.2)",
                borderTop: "4px solid #8b5cf6",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }}></div>
            </div>
          </div>
        </div>

        {/* Linha 2: Rankings */}
        <div className="rankings-row">
          {/* Top Clientes por Faturamento */}
          <div className="ranking-card">
            <div className="ranking-header">
              <GoGraph />
              <h4>Top Clientes por Faturamento</h4>
            </div>
            <div className="ranking-list">
              {[...Array(5)].map((_, i) => (
                <div key={`faturamento-${i}`} className="ranking-item">
                  <div className="ranking-position">{i + 1}</div>
                  <div className="ranking-thumb faturamento">
                    <GoPeople />
                  </div>
                  <div className="ranking-info">
                    <span className="ranking-name">
                      <ContentLoader
                        speed={2}
                        width={180}
                        height={13}
                        backgroundColor={backgroundColor}
                        foregroundColor={foregroundColor}
                      >
                        <rect x="0" y="0" rx="3" ry="3" width="180" height="13" />
                      </ContentLoader>
                    </span>
                    <div className="ranking-tags">
                      <span className="category-tag">
                        <ContentLoader
                          speed={2}
                          width={60}
                          height={10}
                          backgroundColor={backgroundColor}
                          foregroundColor={foregroundColor}
                        >
                          <rect x="0" y="0" rx="3" ry="3" width="60" height="10" />
                        </ContentLoader>
                      </span>
                      <span className="code-tag">
                        <ContentLoader
                          speed={2}
                          width={30}
                          height={10}
                          backgroundColor={backgroundColor}
                          foregroundColor={foregroundColor}
                        >
                          <rect x="0" y="0" rx="3" ry="3" width="30" height="10" />
                        </ContentLoader>
                      </span>
                    </div>
                  </div>
                  <span className="ranking-value faturamento" style={{ fontSize: "1.2em" }}>
                    <ContentLoader
                      speed={2}
                      width={100}
                      height={15}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="100" height="15" />
                    </ContentLoader>
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Top Clientes por Impostos */}
          <div className="ranking-card">
            <div className="ranking-header">
              <GoLaw />
              <h4>Maior Carga Tributária</h4>
            </div>
            <div className="ranking-list">
              {[...Array(5)].map((_, i) => (
                <div key={`impostos-${i}`} className="ranking-item">
                  <div className="ranking-position">{i + 1}</div>
                  <div className="ranking-thumb impostos">
                    <GoLaw />
                  </div>
                  <div className="ranking-info">
                    <span className="ranking-name">
                      <ContentLoader
                        speed={2}
                        width={180}
                        height={13}
                        backgroundColor={backgroundColor}
                        foregroundColor={foregroundColor}
                      >
                        <rect x="0" y="0" rx="3" ry="3" width="180" height="13" />
                      </ContentLoader>
                    </span>
                    <div className="ranking-tags">
                      <span className="category-tag">
                        <ContentLoader
                          speed={2}
                          width={60}
                          height={10}
                          backgroundColor={backgroundColor}
                          foregroundColor={foregroundColor}
                        >
                          <rect x="0" y="0" rx="3" ry="3" width="60" height="10" />
                        </ContentLoader>
                      </span>
                    </div>
                  </div>
                  <span className="ranking-value impostos" style={{ fontSize: "1.2em" }}>
                    <ContentLoader
                      speed={2}
                      width={100}
                      height={15}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="100" height="15" />
                    </ContentLoader>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Linha 3: KPIs Executivos */}
        <div className="executive-kpis-row" style={{ display: "flex", gap: "20px", justifyContent: "space-between" }}>
          {[
            { icon: GoGraph, label: "Faturamento Total", className: "blue" },
            { icon: GoArrowUp, label: "Ticket Médio", className: "green" },
            { icon: GoPeople, label: "Clientes Ativos", className: "orange" },
            { icon: GoLaw, label: "Carga Tributária", className: "red" },
          ].map((item, i) => (
            <div key={`exec-kpi-${i}`} className="exec-kpi-card" style={{ flex: 1 }}>
              <div className={`kpi-icon ${item.className}`}>
                <item.icon />
              </div>
              <div className="kpi-content">
                <span className="kpi-value">
                  <ContentLoader
                    speed={2}
                    width={120}
                    height={20}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="120" height="20" />
                  </ContentLoader>
                </span>
                <span className="kpi-label">{item.label}</span>
                <span className="kpi-change positive">
                  <ContentLoader
                    speed={2}
                    width={100}
                    height={11}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100" height="11" />
                  </ContentLoader>
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Linha 4: Gráfico de Evolução */}
        <div className="advanced-charts-row">
          <div className="advanced-chart-card">
            <div className="chart-header-advanced">
              <div className="chart-title-group">
                <GoCalendar className="chart-icon" />
                <h4>Evolução de Clientes</h4>
              </div>
              <div className="chart-period-selector">
                <button className="period-btn active">12M</button>
                <button className="period-btn">6M</button>
                <button className="period-btn">3M</button>
              </div>
            </div>
            <div className="chart-body">
              <ContentLoader
                speed={2}
                width={1200}
                height={300}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                {[...Array(12)].map((_, i) => {
                  const x = 40 + i * 95;
                  const heights = [180, 220, 160, 240, 200, 190, 210, 170, 230, 195, 215, 185];
                  return (
                    <g key={i}>
                      <rect x={x} y={300 - heights[i]} rx="4" ry="4" width="35" height={heights[i]} />
                      <rect x={x + 40} y={300 - heights[i] * 0.7} rx="4" ry="4" width="35" height={heights[i] * 0.7} />
                    </g>
                  );
                })}
              </ContentLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsStatsLoadingSkeleton;
